export default __webpack_public_path__ + "static/media/beaute.aa6a607d.png";